// Só deve ser usado para Cielo
import {ID, Resource, TAG} from 'simpli-web-sdk'
import InfoCargaAdicionalSchema from '@/schema/InfoCargaAdicional.schema'

export class InfoCargaAdicional extends Resource {
    idCargaFk: number | null = null
    horaFunc: string | null = null
    escopoAtendimento: string | null = null
    ramoAtividade: string | null = null
    gestorComercial: string | null = null
    nomeFantasia: string | null = null
    contato: string | null = null
    observacao: string | null = null
    segmento: string | null = null
    tipoInstalacao: string | null = null
    ocorrencia: string | null = null
    ocorrenciaManutencao: string | null = null
    telefoneAdicional: string | null = null

    readonly $name: string = 'InfoCargaAdicional'

    readonly $endpoint: string = ''

    get $schema() {
        return InfoCargaAdicionalSchema(this)
    }

    get $id() {
        /* TODO: define the ID */
        return 0
    }
    set $id(val: ID) {
        /* TODO: define the ID */
    }

    get $tag() {
        return this.$tag
    }
    set $tag(val: TAG) {
        this.$tag = val
    }
}
